module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/@fuse/components/navigation/horizontal/nav-item/nav-horizontal-item.component.scss
// module id = ./src/@fuse/components/navigation/horizontal/nav-item/nav-horizontal-item.component.scss
// module chunks = main